import React from 'react';
import { useTranslation } from 'react-i18next';
import StandardButton from './StandardButton';
import Text from './Text';

type DiscardChangesModalProps = {
  onDiscard: () => void;
  onCancel: () => void;
};

// This modal is used the same way as the AddressInputForm modal which is
// different from most other modals which is why it is not in the modals folder
export default ({ onDiscard, onCancel }: DiscardChangesModalProps) => {
  const { t } = useTranslation();

  return (
    <>
      <div style={styles.formContainer}>
        <Text style={styles.messageText}>{t('discardChangesModal.message')}</Text>
      </div>

      <div style={styles.buttonContainer}>
        <StandardButton
          label={t('discardChangesModal.discardButton')}
          onClick={onDiscard}
          themeKey="primaryButton"
          containerStyle={styles.saveButton}
          outline
        />
        <StandardButton
          label={t('discardChangesModal.cancelButton')}
          onClick={onCancel}
          themeKey="primaryButton"
          containerStyle={styles.saveButton}
        />
      </div>
    </>
  );
};

const styles: Styles = {
  formContainer: {
    padding: '20px 34px',
    display: 'flex',
    flexDirection: 'column',
  },
  messageText: { textAlign: 'center', fontSize: 15, fontWeight: 500 },
  buttonContainer: {
    display: 'flex',
    padding: '16px 24px',
    backgroundColor: '#ffffff',
    justifyContent: 'center',
    gap: '16px',
  },
  saveButton: { width: '100%' },
};
